// extracted by mini-css-extract-plugin
export default {"button":"TooniesSwapModal_button__dLi38","tokenPreviewImage":"TooniesSwapModal_tokenPreviewImage__7t5oO"};